import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { ISiteNameWithId } from '../../../../siteManagement/serverApi/types/ISiteNameWithId';
import { ICustomViewUsageInfo } from '../../../../spacesPlatform/models/IUsageInfo';
import { IUser } from '../../../../userManagement/users/serverApi/types/IUser';
import { ICustomView } from './ICustomView';

export interface IGetCustomizedViewsResult extends IGetItemsResult {
  customViews: ICustomView[];
  maxStats: ICustomViewUsageInfo;
  sites: ISiteNameWithId[];
  users: IUser[];
}

export class GetCustomizedViewsRequest extends Request<IGetItemsParams, IGetCustomizedViewsResult> {
  constructor(params: IGetItemsParams) {
    super('getCustomizedViews', params);
  }
}
